const HEADER_SELECTOR = '[data-testid="header-wrapper"]';
const SCROLL_CONTAINER_SELECTOR = '.main__content';
const ADDITIONAL_OFFSET = 20;

// Scrolls the error into view below the fixed header, using .main__content (the app's real scroll container) when present
export const scrollErrorIntoView = (element: HTMLElement): void => {
  const header = document.querySelector(HEADER_SELECTOR) ?? document.querySelector('header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  const scrollContainer = element.closest<HTMLElement>(SCROLL_CONTAINER_SELECTOR);

  if (scrollContainer) {
    const containerRect = scrollContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const targetTop =
      scrollContainer.scrollTop +
      (elementRect.top - containerRect.top) -
      headerHeight -
      ADDITIONAL_OFFSET;

    scrollContainer.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    return;
  }

  const elementTop = element.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: Math.max(elementTop - headerHeight - ADDITIONAL_OFFSET, 0),
    behavior: 'smooth',
  });
};
